export default {"src":"/_next/static/media/shield.bd4f4f5f.svg","height":120,"width":148,"blurWidth":0,"blurHeight":0};